import HelperFormatter from "../../helpers/formatter";
import HelperExcel from "../../helpers/exporter";
import Card from "../common/Card";
import { useSelector } from "react-redux";
import * as Icon from "react-feather";
import { Translation, useTranslation } from "react-i18next";
import { upperCase } from "../../utils/manipulateText";
import APIManager from "../../managers/APIManager";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Table from "../common/Table";
import { faGoogleDrive } from "@fortawesome/free-brands-svg-icons";
import _ from "lodash";
import { useBusinessBreakdownAndFilters } from "./BusinessBreakdownAndFilters";

const BusinessReportTable = ({
  table,
  site,
  tableFooter,
  sortOrder,
  setTable,
}) => {
  const { t } = useTranslation();
  const { tableBreakdowns, businessCurr } = useBusinessBreakdownAndFilters();

  const tableHeaders = [
    {
      content: "day",
      key: "day",
      onClick: () => sortTable("day"),
    },
    {
      content: "month",
      key: "month",
      onClick: () => sortTable("month"),
    },
    {
      content: "site",
      key: "site",
      onClick: () => sortTable("site"),
    },
    {
      content: "request",
      key: "request",
      onClick: () => sortTable("request"),
    },
    {
      content: "view",
      key: "view",
      onClick: () => sortTable("view"),
    },
    {
      content: "gross revenue",
      key: "grossSpent",
      onClick: () => sortTable("grossSpent"),
    },

    {
      content: "partner net revenue",
      key: "netSpent",
      onClick: () => sortTable("netSpent"),
    },
    {
      content: "empower revenue",
      key: "empowerSpent",
      onClick: () => sortTable("empowerSpent"),
    },
    {
      content: "business manager revenue",
      key: "bussinessSpent",
      onClick: () => sortTable("bussinessSpent"),
    },
    {
      content: "business revenue ratio",
      key: "bussinessSpentRatio",
      onClick: () => sortTable("bussinessSpentRatio"),
    },
  ];

  const sortTable = (field) => {
    sortOrder.current = sortOrder.current !== "asc" ? "asc" : "desc";
    const tblTmp = table.tbl;
    if (field === "date" || field === "day") {
      const sortedData = tblTmp
        .map((item) => {
          return {
            ...item,
            sortableDay: new Date(item?.day.split(".").reverse().join("-")),
          };
        })
        .sort((a, b) => {
          if (sortOrder.current === "asc") {
            return a.sortableDay - b.sortableDay;
          } else {
            return b.sortableDay - a.sortableDay;
          }
        })
        .map((item) => {
          return {
            ...item,
            sortableDay: undefined,
          };
        });

      setTable({
        ...table,
        tbl: sortedData,
      });
    } else {
      setTable({ ...table, tbl: _.orderBy(tblTmp, field, sortOrder.current) });
    }
  };

  const getTableHeaders = () => {
    return tableHeaders.filter((header) => {
      if (header.key === "day") {
        return tableBreakdowns.indexOf("day") !== -1;
      } else if (header.key === "month") {
        return tableBreakdowns.indexOf("month") !== -1;
      } else if (header.key === "site") {
        return tableBreakdowns.indexOf("site") !== -1;
      } else if (header.key === "request") {
        return tableBreakdowns.indexOf("request") !== -1;
      } else if (header.key === "view") {
        return tableBreakdowns.indexOf("view") !== -1;
      } else if (header.key === "grossSpent") {
        return tableBreakdowns.indexOf("grossSpent") !== -1;
      } else if (header.key === "netSpent") {
        return tableBreakdowns.indexOf("netSpent") !== -1;
      } else if (header.key === "empowerSpent") {
        return tableBreakdowns.indexOf("empowerSpent") !== -1;
      } else if (header.key === "bussinessSpent") {
        return tableBreakdowns.indexOf("bussinessSpent") !== -1;
      } else if (header.key === "bussinessSpentRatio") {
        return tableBreakdowns.indexOf("bussinessSpentRatio") !== -1;
      } else {
        return false;
      }
    });
  };

  const footerSection =
    Object.keys(tableFooter).length > 0 ? (
      <Table.Row key={Math.random()} className="bg-gray-200">
        {tableBreakdowns.indexOf("day") !== -1 ? (
          <Table.Col className="border text-center uppercase">
            <strong>{upperCase(t(tableFooter?.day))}</strong>
          </Table.Col>
        ) : null}
        {tableBreakdowns.indexOf("month") !== -1 ? (
          <Table.Col className="border text-center uppercase">
            <strong>{upperCase(t(tableFooter?.month))}</strong>
          </Table.Col>
        ) : null}

        {tableBreakdowns.indexOf("site") !== -1 ? (
          <Table.Col className="border text-center uppercase">
            <strong>{upperCase(t(tableFooter?.site))}</strong>
          </Table.Col>
        ) : null}

        {tableBreakdowns.indexOf("request") !== -1 ? (
          <Table.Col className="border text-center uppercase">
            <strong>{HelperFormatter.number(tableFooter?.request)}</strong>
          </Table.Col>
        ) : null}

        {tableBreakdowns.indexOf("view") !== -1 ? (
          <Table.Col className="border text-center uppercase">
            <strong>{HelperFormatter.number(tableFooter?.view)}</strong>
          </Table.Col>
        ) : null}

        {tableBreakdowns.indexOf("grossSpent") !== -1 ? (
          <Table.Col className="border text-center uppercase">
            <strong>
              {HelperFormatter.currency(businessCurr)(
                tableFooter.grossSpent || 0
              )}
            </strong>
          </Table.Col>
        ) : null}

        {tableBreakdowns.indexOf("netSpent") !== -1 ? (
          <Table.Col className="border text-center uppercase">
            <strong>
              {HelperFormatter.currency(businessCurr)(tableFooter.spent || 0)}
            </strong>
          </Table.Col>
        ) : null}

        {tableBreakdowns.indexOf("empowerSpent") !== -1 ? (
          <Table.Col className="border text-center uppercase">
            <strong>
              {HelperFormatter.currency(businessCurr)(
                tableFooter.empowerSpent || 0
              )}
            </strong>
          </Table.Col>
        ) : null}

        {tableBreakdowns.indexOf("bussinessSpent") !== -1 ? (
          <Table.Col className="border text-center uppercase">
            <strong>
              <strong>
                {HelperFormatter.currency(businessCurr)(
                  tableFooter.bussinessSpent || 0
                )}
              </strong>
            </strong>
          </Table.Col>
        ) : null}

        {tableBreakdowns.indexOf("bussinessSpentRatio") !== -1 ? (
          <Table.Col className="border text-center uppercase">
            <strong>
              {HelperFormatter.percentage(
                (tableFooter?.bussinessSpentRatio || 0) * 100
              )}
            </strong>
          </Table.Col>
        ) : null}
      </Table.Row>
    ) : null;

  return (
    <Card title="report" className="mb-5">
      <div className="float-right flex ">
        <button
          style={{ marginTop: "-30px" }}
          onClick={() => {
            HelperExcel.exportExcel(
              [].concat(table.tbl),
              "DailyBreakdown",
              true,
              currency
            );
          }}
          className="mx-4 mt-4 pull-right text-sm py-1"
        >
          <Icon.Download
            className="pull-left mt-1 mr-1 text-gray-600"
            width="16"
            height="16"
          />
          <label
            style={{
              float: "right",
              color: "#718096",
              cursor: "pointer",
              marginTop: "1px",
            }}
          >
            /<Translation>{(t) => upperCase(t("download"))}</Translation>
          </label>
        </button>
        <button
          style={{ marginTop: "-30px" }}
          onClick={() => {
            var data = HelperExcel.exportExcel(
              [].concat(table.tbl),
              "DailyBreakdown",
              true,
              currency,
              true
            );
            const fileName =
              site.fqdn + " - " + new Date().toLocaleDateString();
            APIManager.exportToDrive(fileName, data).then((res) => {
              window.open(res.url, "_blank");
            });
          }}
          className="mx-4 mt-4 pull-right text-sm py-1"
        >
          <FontAwesomeIcon
            icon={faGoogleDrive}
            style={{
              width: "16px",
              height: "16px",
            }}
            className="pull-left mt-1 mr-1 text-gray-600"
          />
          <label
            style={{
              float: "right",
              color: "#718096",
              cursor: "pointer",
              marginTop: "1px",
            }}
          >
            /<Translation>{(t) => upperCase(t("open in drive"))}</Translation>
          </label>
        </button>
      </div>

      <div className="overflow-x-scroll">
        <Table
          headers={getTableHeaders(table.tbl[0])}
          footerSection={footerSection}
        >
          {table.tbl.map((row) => (
            <Table.Row
              key={Math.random()}
              className="even:bg-gray-100 hover:bg-gray-200"
            >
              {tableBreakdowns.indexOf("day") !== -1 ? (
                <Table.Col className="border text-center">
                  <strong>{row?.day}</strong>
                </Table.Col>
              ) : null}

              {tableBreakdowns.indexOf("month") !== -1 ? (
                <Table.Col className="border text-center">
                  <strong>{row?.month}</strong>
                </Table.Col>
              ) : null}

              {tableBreakdowns.indexOf("site") !== -1 ? (
                <Table.Col className="border text-center">
                  <strong>{row?.site?.name}</strong>
                </Table.Col>
              ) : null}

              {tableBreakdowns.indexOf("request") !== -1 ? (
                <Table.Col className="border text-center">
                  {HelperFormatter.number(row?.request)}
                </Table.Col>
              ) : null}

              {tableBreakdowns.indexOf("view") !== -1 ? (
                <Table.Col className="border text-center">
                  {HelperFormatter.number(row?.view)}
                </Table.Col>
              ) : null}

              {tableBreakdowns.indexOf("grossSpent") !== -1 ? (
                <Table.Col className="border text-center">
                  {HelperFormatter.currency(businessCurr)(row.grossSpent || 0)}
                </Table.Col>
              ) : null}

              {tableBreakdowns.indexOf("netSpent") !== -1 ? (
                <Table.Col className="border text-center">
                  {HelperFormatter.currency(businessCurr)(row.netSpent || 0)}
                </Table.Col>
              ) : null}

              {tableBreakdowns.indexOf("empowerSpent") !== -1 ? (
                <Table.Col className="border text-center">
                  {HelperFormatter.currency(businessCurr)(
                    row.empowerSpent || 0
                  )}
                </Table.Col>
              ) : null}

              {tableBreakdowns.indexOf("bussinessSpent") !== -1 ? (
                <Table.Col className="border text-center">
                  {HelperFormatter.currency(businessCurr)(
                    row.bussinessSpent || 0
                  )}
                </Table.Col>
              ) : null}

              {tableBreakdowns.indexOf("bussinessSpentRatio") !== -1 ? (
                <Table.Col className="border text-center">
                  {HelperFormatter.percentage(
                    (row?.bussinessSpentRatio || 0) * 100
                  )}
                </Table.Col>
              ) : null}
            </Table.Row>
          ))}
        </Table>
      </div>
    </Card>
  );
};

export default BusinessReportTable;
